<template>
  <div v-if="!data.disabled" class="provision">
    <p><strong v-html="data.title"></strong> <span v-html="data.body"></span></p>
  </div>
</template>

<script>
export default {
  name: 'disclaimer',
  props: {
    'data': {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// BlockProvision.vue?9ed555e6